// extracted by mini-css-extract-plugin
module.exports = {"head":"setting-router_head__3FALT"};